export const INVALID_EMAIL_USERNAMES = new Set(['test', 'dsa', 'fdsa', 'mail', 'email']);

export const EMAIL_DOMAIN_TYPOS = new Set([
    // Hotmail typos
    'otmail', 'htmail', 'homail', 'hotail', 'hotmil', 'hotmal', 'hotmai',
    'hhotmail', 'hootmail', 'hottmail', 'hotmmail', 'hotmaail', 'hotmaiil', 'hotmaill',
    'ohtmail', 'htomail', 'homtail', 'hotamil', 'hotmial', 'hotmali',
    'gotmail', 'yotmail', 'uotmail', 'jotmail', 'notmail', 'botmail',
    'hitmail', 'h9tmail', 'h0tmail', 'hptmail', 'hltmail', 'hktmail',
    'hormail', 'ho5mail', 'ho6mail', 'hoymail', 'hohmail', 'hogmail', 'hofmail',
    'hotnail', 'hotjail', 'hotkail',
    'hotmqil', 'hotmwil', 'hotmsil', 'hotmxil', 'hotmzil',
    'hotmaul', 'hotma8l', 'hotma9l', 'hotmaol', 'hotmall', 'hotmakl', 'hotmajl',
    'hotmaik', 'hotmaio', 'hotmaip',
    'ghotmail', 'hgotmail', 'yhotmail', 'hyotmail', 'uhotmail', 'huotmail',
    'jhotmail', 'hjotmail', 'nhotmail', 'hnotmail', 'bhotmail', 'hbotmail',
    'hiotmail', 'hoitmail', 'h9otmail', 'ho9tmail', 'h0otmail', 'ho0tmail',
    'hpotmail', 'hoptmail', 'hlotmail', 'holtmail', 'hkotmail', 'hoktmail',
    'hortmail', 'hotrmail', 'ho5tmail', 'hot5mail', 'ho6tmail', 'hot6mail',
    'hoytmail', 'hotymail', 'hohtmail', 'hothmail', 'hogtmail', 'hotgmail', 'hoftmail', 'hotfmail',
    'hotnmail', 'hotmnail', 'hotjmail', 'hotmjail', 'hotkmail', 'hotmkail',
    'hotmqail', 'hotmaqil', 'hotmwail', 'hotmawil', 'hotmsail', 'hotmasil',
    'hotmxail', 'hotmaxil', 'hotmzail', 'hotmazil',
    'hotmauil', 'hotmaiul', 'hotma8il', 'hotmai8l', 'hotma9il', 'hotmai9l',
    'hotmaoil', 'hotmaiol', 'hotmalil', 'hotmakil', 'hotmaikl', 'hotmajil', 'hotmaijl',
    'hotmailk', 'hotmailo', 'hotmaipl', 'hotmailp',
    // Outlook typos
    'utlook', 'otlook', 'oulook', 'outook', 'outlok', 'outloo',
    'ooutlook', 'ouutlook', 'outtlook', 'outllook', 'outloook', 'outlookk',
    'uotlook', 'otulook', 'oultook', 'outolok', 'outloko',
    'iutlook', '9utlook', '0utlook', 'putlook', 'lutlook', 'kutlook',
    'oytlook', 'o7tlook', 'o8tlook', 'oitlook', 'oktlook', 'ojtlook', 'ohtlook',
    'ourlook', 'ou5look', 'ou6look', 'ouylook', 'ouhlook', 'ouglook', 'ouflook',
    'outkook', 'outoook', 'outpook',
    'outliok', 'outl9ok', 'outl0ok', 'outlpok', 'outllok', 'outlkok',
    'outloik', 'outlo9k', 'outlo0k', 'outlopk', 'outlolk', 'outlokk',
    'outlooj', 'outlooi', 'outlooo', 'outlool', 'outloom',
    'ioutlook', 'oiutlook', '9outlook', 'o9utlook', '0outlook', 'o0utlook',
    'poutlook', 'oputlook', 'loutlook', 'olutlook', 'koutlook', 'okutlook',
    'oyutlook', 'ouytlook', 'o7utlook', 'ou7tlook', 'o8utlook', 'ou8tlook',
    'oiutlook', 'ouitlook', 'okutlook', 'ouktlook', 'ojutlook', 'oujtlook', 'ohutlook', 'ouhtlook',
    'ourtlook', 'outrlook', 'ou5tlook', 'out5look', 'ou6tlook', 'out6look',
    'ouytlook', 'outylook', 'ouhtlook', 'outhlook', 'ougtlook', 'outglook', 'ouftlook', 'outflook',
    'outklook', 'outlkook', 'outolook', 'outplook', 'outlpook',
    'outliook', 'outloiok', 'outl9ook', 'outlo9ok', 'outl0ook', 'outlo0ok',
    'outlpook', 'outlopok', 'outlolok', 'outlkook', 'outlokok',
    'outloiok', 'outlooik', 'outlo9ok', 'outloo9k', 'outlo0ok', 'outloo0k',
    'outlopok', 'outloopk', 'outlolok', 'outloolk', 'outlookk',
    'outloojk', 'outlookj', 'outlooik', 'outlooki', 'outlooko', 'outlookl', 'outloomk', 'outlookm',
    // Gmail typos
    'gail', 'gmil', 'gmal', 'gmai',
    'ggmail', 'gmmail', 'gmaail', 'gmaiil', 'gmaill',
    'mgail', 'gamil', 'gmial', 'gmali',
    'fmail', 'tmail', 'ymail', 'hmail', 'bmail', 'vmail',
    'gnail', 'gjail', 'gkail',
    'gmqil', 'gmwil', 'gmsil', 'gmxil', 'gmzil',
    'gmaul', 'gma8l', 'gma9l', 'gmaol', 'gmall', 'gmakl', 'gmajl',
    'gmaik', 'gmaio', 'gmaip',
    'fgmail', 'gfmail', 'tgmail', 'gtmail', 'ygmail', 'gymail',
    'hgmail', 'ghmail', 'bgmail', 'gbmail', 'vgmail', 'gvmail',
    'gnmail', 'gmnail', 'gjmail', 'gmjail', 'gkmail', 'gmkail',
    'gmqail', 'gmaqil', 'gmwail', 'gmawil', 'gmsail', 'gmasil',
    'gmxail', 'gmaxil', 'gmzail', 'gmazil',
    'gmauil', 'gmaiul', 'gma8il', 'gmai8l', 'gma9il', 'gmai9l',
    'gmaoil', 'gmaiol', 'gmalil', 'gmakil', 'gmaikl', 'gmajil', 'gmaijl',
    'gmailk', 'gmailo', 'gmaipl', 'gmailp',
    // AOL typos
    'ol', 'al', 'ao',
    'aaol', 'aool', 'aoll',
    'oal', 'alo',
    'qol', 'wol', 'sol', 'xol', 'zol',
    'ail', 'a9l', 'a0l', 'apl', 'all', 'akl',
    'aok', 'aoo', 'aop',
    'qaol', 'aqol', 'waol', 'awol', 'saol', 'asol', 'xaol', 'axol', 'zaol', 'azol',
    'aiol', 'aoil', 'a9ol', 'ao9l', 'a0ol', 'ao0l', 'apol', 'aopl', 'alol', 'akol', 'aokl',
    'aolk', 'aolo', 'aolp',
    // Yahoo typos
    'ahoo', 'yhoo', 'yaoo', 'yaho',
    'yyahoo', 'yaahoo', 'yahhoo', 'yahooo',
    'ayhoo', 'yhaoo', 'yaoho',
    'tahoo', '6ahoo', '7ahoo', 'uahoo', 'jahoo', 'hahoo', 'gahoo',
    'yqhoo', 'ywhoo', 'yshoo', 'yxhoo', 'yzhoo',
    'yagoo', 'yayoo', 'yauoo', 'yajoo', 'yanoo', 'yaboo',
    'yahio', 'yah9o', 'yah0o', 'yahpo', 'yahlo', 'yahko',
    'yahoi', 'yaho9', 'yaho0', 'yahop', 'yahol', 'yahok',
    'tyahoo', 'ytahoo', '6yahoo', 'y6ahoo', '7yahoo', 'y7ahoo',
    'uyahoo', 'yuahoo', 'jyahoo', 'yjahoo', 'hyahoo', 'yhahoo', 'gyahoo', 'ygahoo',
    'yqahoo', 'yaqhoo', 'ywahoo', 'yawhoo', 'ysahoo', 'yashoo',
    'yxahoo', 'yaxhoo', 'yzahoo', 'yazhoo',
    'yaghoo', 'yahgoo', 'yayhoo', 'yahyoo', 'yauhoo', 'yahuoo',
    'yajhoo', 'yahjoo', 'yanhoo', 'yahnoo', 'yabhoo', 'yahboo',
    'yahioo', 'yahoio', 'yah9oo', 'yaho9o', 'yah0oo', 'yaho0o',
    'yahpoo', 'yahopo', 'yahloo', 'yaholo', 'yahkoo', 'yahoko',
    'yahoio', 'yahooi', 'yaho9o', 'yahoo9', 'yaho0o', 'yahoo0',
    'yahopo', 'yahoop', 'yaholo', 'yahool', 'yahoko', 'yahook',
    // Other
    'getnada', 'netetrt',
]);

export const KNOWN_GOOD_EMAIL_DOMAINS = new Set([
    'loanscanada.ca', 'gmail.com', 'hotmail.com', 'outlook.com',
    'yahoo.com', 'icloud.com', 'yahoo.ca', 'live.ca', 'hotmail.ca',
    'live.com', 'msn.com', 'shaw.ca', 'rogers.com', 'hotmail.fr',
    'outlook.fr', 'telus.net',
]);
